import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface SidebarState {
  isCollapsed: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  setIsCollapsed: (isCollapsed: boolean) => void;
  toggleCollapsed: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  devtools(
    persist(
      (set) => ({
        isCollapsed: false,
        isOpen: false,
        setIsOpen: (isOpen: boolean) => set({ isOpen }),
        setIsCollapsed: (isCollapsed: boolean) => set({ isCollapsed }),
        toggleCollapsed: () =>
          set((state) => ({ isCollapsed: !state.isCollapsed })),
      }),
      {
        name: 'sidebar-state',
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);
